import { useState } from 'react';

import { showDeleteToast, showSuccessToast } from './components/AlertToast';

const useAlerts = initialAlerts => {
  const [alerts, setAlerts] = useState(initialAlerts);

  const addAlert = newAlert => {
    setAlerts([...alerts, newAlert]);
    showSuccessToast();
  };

  const editAlert = (previousId, newAlert) => {
    setAlerts(
      alerts.map(alert => (alert.id === previousId ? newAlert : alert))
    );
    showSuccessToast();
  };

  const removeAlert = alertId => {
    setAlerts(alerts.filter(alert => alert.id !== alertId));
    showDeleteToast();
  };

  return {
    addAlert,
    editAlert,
    removeAlert,
    alerts
  };
};

export default useAlerts;
